import React from "react";
import Box from "@material-ui/core/Box";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import style from "./InfoSectionBlogStyle"
import image1 from "assets/img/25/Imagen 1.jpeg";
import InfoSectionBlogMobile from "./InfoSectionBlogMobile";

const useStyles = makeStyles(style)

const InfoSectionBlog = ({ t }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();

  if (isMobile) {
    return <InfoSectionBlogMobile t={t} />;
  }

  return (
    <Box className={classes.mainBox}>
      <GridContainer className={classes.mainGridContainer}>
        <GridItem xs={12} sm={12} md={6}>
          <Typography variant="h4" component="h2" gutterBottom className={classes.infoText}>
            {t("mainTitlePart1")}
          </Typography>
          <Typography variant="subtitle1" style={{ fontWeight: "bold" }} gutterBottom className={classes.infoText}>
            {t("mainSubtitle")}
          </Typography>
          <Typography variant="body1" className={classes.infoText}>
            {t("meetingText")}
          </Typography>
        </GridItem>

        <GridItem xs={12} sm={12} md={6}>
          <Box
            component="img"
            src={image1}
            alt="Rising Together"
            style={{
              width: "100%",
              height: "auto",
              maxHeight: isMobile ? "none" : 300,
              objectFit: "cover",
              borderRadius: 10,
              display: "block",
            }}
          />
        </GridItem>
      </GridContainer>
    </Box>
  );
};

export default InfoSectionBlog;
